export default "__VITE_ASSET__COUy1u7t__"